<template>
  <b-link v-if="!float" @click="onClick" class="button-chat">
    <i class="icon-chat" />
    <b-badge v-if="count > 0" pill variant="danger">{{ count }}</b-badge>
  </b-link>
  <b-link v-else @click="onClick" class="button-chat-float">
    <i class="icon-send-message" />
    <b-badge v-if="count > 0" pill variant="danger">{{ count }}</b-badge>
  </b-link>
</template>

<script>
export default {
  name: "AppButtonChat",
  props: {
    count: {
      type: Number,
      required: false,
      default: 0,
    },
    float: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.button-chat {
  right: 1.1875rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  color: $white;
  .badge {
    position: relative;
    right: -0.5625rem;
    top: -0.625rem;
    margin-left: -1.125rem;
  }
}
.button-chat-float {
  position: fixed;
  bottom: 1.75rem;
  right: 1.75rem;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  background-color: $white;
  box-shadow: 0 0.375rem 1rem 0 rgba($black, 0.15);
  text-align: center;
  line-height: 4.5rem;
  z-index: 2;
  @include transition-framework;
  @include themify($themes) {
    i {
      font-size: 2.5rem;
      color: themed("primary");
    }
    .badge {
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
      font-size: 1rem;
    }
    &.active {
      right: calc(37% + 32px);
    }
  }
}
@include media-breakpoint-down(md) {
  display: none;
}

@include media-breakpoint-up(xl) {
  display: none;
}
</style>
